/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiPersonType {
    INDIVIDUAL = 'INDIVIDUAL',
    PRIVATE = 'PRIVATE',
    BUSINESS = 'BUSINESS',
    LEGAL = 'LEGAL',
    UNDEFINED = 'UNDEFINED'
}


export function instanceOfInternalApiPersonType(value: any): boolean {
    for (const key in InternalApiPersonType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiPersonType, key)) {
            if (InternalApiPersonType[key as keyof typeof InternalApiPersonType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiPersonTypeFromJSON(json: any): InternalApiPersonType {
    return InternalApiPersonTypeFromJSONTyped(json, false);
}

export function InternalApiPersonTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiPersonType {
    return json as InternalApiPersonType;
}

export function InternalApiPersonTypeToJSON(value?: InternalApiPersonType | null): any {
    return value as any;
}

export function InternalApiPersonTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiPersonType {
    return value as InternalApiPersonType;
}

